"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.metadataSelector = exports.formLabelSelector = exports.formInfoSelector = exports.formIdsSelector = exports.submissionSelector = exports.currentModelsSelector = exports.allFormRulesetsSelector = exports.rulesetsSelector = exports.useFormOrCurrent = void 0;
const lodash_memoize_1 = __importDefault(require("lodash.memoize"));
const useFormOrCurrent = ({ rex }, { useForm } = {}) => {
    if (!useForm || !useForm.id) {
        return rex.currentForm;
    }
    if (useForm.childId) {
        if (rex.version[useForm.id] > 1) {
            return {
                id: useForm.id,
                index: 0,
                stage: rex.childNames[useForm.id][useForm.childId],
            };
        }
        return {
            id: useForm.id,
            index: rex.childNames[useForm.id][useForm.childId],
            stage: 0,
        };
    }
    if (rex.version[useForm.id] > 1) {
        return {
            id: useForm.id,
            index: 0,
            stage: useForm.index,
        };
    }
    return useForm;
};
exports.useFormOrCurrent = useFormOrCurrent;
const rulesetsSelector = ({ rex }, customFormId) => rex.rulesets[customFormId || rex.currentForm.id];
exports.rulesetsSelector = rulesetsSelector;
const allFormRulesetsSelector = (state, props) => {
    const { id, index } = (0, exports.useFormOrCurrent)(state, props);
    const form = state.rex.forms[id];
    if (form) {
        return form[index].rulesets || {};
    }
    return {};
};
exports.allFormRulesetsSelector = allFormRulesetsSelector;
const currentModelsSelector = ({ rex }, { formId }) => rex.models[formId || rex.currentForm.id];
exports.currentModelsSelector = currentModelsSelector;
const submissionSelector = ({ rex }, { formId, formIndex, submission }) => {
    if (rex.version[formId] > 1) {
        const request = rex.formsv2[formId].submissions?.requests?.[submission];
        if (request?.type === 'profile-request') {
            return {
                submissionType: 'profile-request',
                action: '${services.ixprofiler.universal}/' + request.template,
                mediatype: 'application/xml',
                method: 'post',
                submissionData: request.data,
            };
        }
        if (request?.type === 'generic-request') {
            return {
                submissionType: 'generic-request',
                action: request.url,
                mediatype: 'application/x-www-form-urlencoded',
                method: 'get',
                separator: '&amp;',
                target: '_blank',
                submissionData: request.data,
            };
        }
        return undefined;
    }
    return rex.forms[formId][formIndex].submissions?.[submission];
};
exports.submissionSelector = submissionSelector;
const formIdsSelector = (state) => state.rex.formIds;
exports.formIdsSelector = formIdsSelector;
const formLabelsSelector = (0, lodash_memoize_1.default)((forms) => (forms ? forms.map(({ label = '' }) => label) : []), (forms, id) => id);
const formInfoSelector = (state, props) => {
    const { id, index } = (0, exports.useFormOrCurrent)(state, props);
    const labels = formLabelsSelector(state.rex.forms[id], id);
    return {
        formLabels: labels,
        formCount: labels.length,
        formIds: (0, exports.formIdsSelector)(state),
        formId: id,
        formIndex: index,
    };
};
exports.formInfoSelector = formInfoSelector;
const formLabelSelector = (state, props) => {
    const { id, index } = (0, exports.useFormOrCurrent)(state, props);
    return state.rex.forms[id][index].label || '';
};
exports.formLabelSelector = formLabelSelector;
const noMetadata = {};
const metadataSelector = (state, props) => {
    const { id, index } = (0, exports.useFormOrCurrent)(state, props);
    return state.rex.forms[id][index].metadata || noMetadata;
};
exports.metadataSelector = metadataSelector;
//# sourceMappingURL=selectors.js.map